/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInTaxEditor extends Common.GridEditorBase<BranchInTaxRow> {
        protected getColumnsKey() { return "Common.CommonTax"; }
        protected getDialogType() { return BranchInTaxDialog; }
        protected getLocalTextPrefix() { return BranchInTaxRow.localTextPrefix; }
        protected form: BranchInTaxForm;

        public PartyId: number;
        public LaborListId: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public ItemAtbId: number;

        constructor(container: JQuery) {
            super(container);
          //  this.slickGrid.setOptions({ forceFitColumns: true });
            //this.toolbar.element.hide;

            ////grid-toolbar s-Toolbar clearfix
        }
        public getData(TaxDetails) {
            var tmp =[];
            for (let orderDetail of TaxDetails) {
                orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                var x = orderDetail;
                tmp.push(orderDetail);
            }
            return tmp;

        }



        public DeleteTax() {
            //var item = this.itemAt(row);
            //var id = this.id(item);
            //this.view.deleteItem(id);
            //this.view.refresh();

            var data = [];
            this.view.setItems(data, false);
            this.view.refresh();
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }


        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.LabourMasterSelectGrid;

            //buttons.push({
            //    title: "Apply Labor Charges",
            //    cssClass: "add-button",
            //    onClick: () => {
            //        var pickerDialog = new _Ext.GridItemPickerDialog({
            //            gridType: grid, multiple: true,
            //            preSelectedKeys: this.value.map(k => k.ProcessId), filterField: "AtbId", filterValue: this.ItemAtbId
            //        });

            //        pickerDialog.onSuccess = (selectedItems: any[]) => {
            //            let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n. == t.ProcessId) });

            //            var SalesLaborDetails = [];
            //            selectedItems2.forEach(function (x) {

            //               // SalesLaborDetails.push(SalesLabor);
            //            });

            //            for (let LaborDetail of SalesLaborDetails) {
            //                LaborDetail[this.getIdProperty()] = "`" + this.nextId++;
            //                var x = LaborDetail;
            //                this.view.addItem(LaborDetail);
            //            }

            //        }

            //        pickerDialog.dialogOpen();
            //    }
            //});

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

    }
}